import React, {useEffect} from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';


import * as modalConstants from './modalConstants';
import * as styleUtils from '../../../utils/styleUtils';

import {CloseIcon} from '../Icon';

import styles from './Modal.scss';


function Modal({children, doClose, size, type}) {

    const modalContainer = document.getElementById('modalRoot');

    // close on ESC key but only if not input field
    const escapeEventHandler = event => {

        const inputTypes = [
            'input',
            'textarea'
        ];

        const type = event.currentTarget?.type || undefined;
        if (event.key !== 'Escape' || (type && inputTypes.includes(type))) {

            return;
        }

        doClose();
    };

    // bring browser into modal-mode (window scrolling disabled etc.)
    useEffect(() => {

        const bodyStyles = window.document.body.style;
        const storedStyles = {
            overflow: bodyStyles.overflow
        };

        bodyStyles.overflow = 'hidden';

        document.addEventListener('keyup', escapeEventHandler);

        return () => {

            Object.entries(storedStyles)
                .forEach(([style, value]) => {
                    bodyStyles[style] = value;
                });

            document.removeEventListener('keyup', escapeEventHandler);
        };

    }, []);

    return ReactDOM.createPortal(
        (
            <div
                className={styleUtils.toClasses(styles.modalOverlay, size, type)}
                onClick={() => doClose()}
            >
                <div
                    aria-modal={true}
                    className={styles.modalContainer}
                    onClick={event => {
                        event.preventDefault();
                        event.stopPropagation();
                    }}
                    role={'dialog'}
                >
                    <CloseIcon onClick={() => doClose()}/>

                    <div className={styles.modalContent}>
                        {children}
                    </div>
                </div>
            </div>
        ),
        modalContainer
    );
}


Modal.propTypes = {
    children: PropTypes.any,
    doClose: PropTypes.func.isRequired,
    size: PropTypes.oneOf(modalConstants.SIZES),
    type: PropTypes.oneOf(modalConstants.TYPES)
};

Modal.defaultProps = {
    size: modalConstants.SIZE_MEDIUM,
    type: modalConstants.TYPE_WHITE
};


export default Modal;
